<template>
    <div class="preloader" v-show="display" :class="classes" >
        <div class="logo-inner">
            <div class="rect1"></div>
            <div class="rect2"></div>
            <div class="rect3"></div>
            <div class="rect4"></div>
        </div>
    </div>
</template>

<script>
    export default{
        props : {
            display: {
                type        :Boolean,
                required    :true,
			},
			size : {
				type        :String,
                required    :false,
            },
            background: {
                type        : Boolean,
                required    : false,
                default     : true
            }
        },
        computed: {
            classes(){
                let classes = []
                classes.push('loader-'+this.size)
                if(this.background){
                    classes.push('background')
                }
                return classes
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~@sellsy/styleguide/src/_variables';

	.preloader{
		display     : block;
		position    : absolute;
		top         : 0;
		left        : 0;
		width       : 100%;
		height      : 100%;
		z-index     : 2006;

        &.background{
            background-color: rgba(255, 255, 255, 0.7);
        }

		&.loader-small {
			.logo-inner {
				height : 24px !important;

				&>div {
					margin	: 0px 2px 	!important;
					width	: 2px 		!important;
				}
			}
		}

		&.loader-big {
			.logo-inner {
				height : 64px !important;

				&>div {
					margin	: 0px 4px 	!important;
					width	: 4px 		!important;
				}
			}
		}
		
		&.no-overlay { background-color : transparent; }

		.logo-inner {
			height      : 40px;
			position    : absolute;
			top         : 50%;
			left        : 50%;
			transform   : translate(-50%, -50%); 


			& > div {
				display     : inline-block;
				width       : 4px;
				height      : 100%;
				margin      : 0 4px;
				z-index     : 1001;
				
				background-color : $gray-100;
				
				animation           : sk-stretchdelay 1.2s infinite ease-in-out;
				-webkit-animation   : sk-stretchdelay 1.2s infinite ease-in-out;

				&.rect2 {
					animation-delay			: -1.1s;
					-webkit-animation-delay	: -1.1s;
				}
				&.rect3 {
					animation-delay			: -1.0s;
					-webkit-animation-delay	: -1.0s;
				}
				&.rect4 {
					animation-delay			: -0.9s;
					-webkit-animation-delay	: -0.9s;
				}
			}
		}
	}

	@keyframes sk-stretchdelay {
		0%,
		40%,
		100% {
			transform			: scaleY(0.66);
			-webkit-transform	: scaleY(0.66);
		}  
		20% {
			transform			: scaleY(1);
			-webkit-transform	: scaleY(1);
		}
	}
</style>
